import React from 'react';
import { motion } from 'framer-motion';
import { responsables, normasEstudiantes, normasPadres, normasDocentes } from '../data/normasdeConvivenvia.ts';

const NormasDeConvivencia: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="max-w-7xl mx-auto px-4 py-8 mt-16"
    >
      <h1 className="text-4xl font-bold text-center mb-12 text-blue-800">Normas de Convivencia</h1>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold text-blue-700 mb-4">Normas Generales</h2>
        <p className="text-lg text-gray-700 leading-relaxed">
          Para la generación de un clima adecuado para el logro de los aprendizajes de los estudiantes, y conforme a las
          necesidades y características de la IE, la convivencia escolar se define como: el instrumento que contribuye a la
          promoción de la convivencia escolar democrática, a través del establecimiento de pautas de comportamiento y medidas correctivas...
        </p>
      </section>

      <section className="mb-12">
        <h3 className="text-2xl font-semibold text-blue-700 mb-4">Responsables - Comité de Gestión del Bienestar</h3>
        <ul className="list-disc pl-6 space-y-2 text-gray-700 text-lg">
          {responsables.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="mb-12">
        <h3 className="text-2xl font-semibold text-blue-700 mb-4">Normas de los Estudiantes</h3>
        <ul className="list-disc pl-6 space-y-2 text-gray-700 text-lg">
          {normasEstudiantes.map((norma, index) => (
            <li key={index}>{norma}</li>
          ))}
        </ul>
      </section>

      <section className="mb-12">
        <h3 className="text-2xl font-semibold text-blue-700 mb-4">Normas de los Padres de Familia</h3>
        <div className="overflow-x-auto rounded-lg shadow-md">
          <table className="min-w-full bg-white">
            <thead className="bg-blue-600 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-lg font-semibold">Acuerdos</th>
                <th className="px-6 py-3 text-left text-lg font-semibold">Acción Reparadora</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {normasPadres.map((item, index) => (
                <tr key={index} className="hover:bg-gray-100 transition-colors">
                  <td className="px-6 py-4">{item.acuerdo}</td>
                  <td className="px-6 py-4">{item.accion}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h3 className="text-2xl font-semibold text-blue-700 mb-4">Normas de los Docentes</h3>
        <div className="overflow-x-auto rounded-lg shadow-md">
          <table className="min-w-full bg-white">
            <thead className="bg-blue-600 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-lg font-semibold">Acuerdos</th>
                <th className="px-6 py-3 text-left text-lg font-semibold">Acción Reparadora</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {normasDocentes.map((item, index) => (
                <tr key={index} className="hover:bg-gray-100 transition-colors">
                  <td className="px-6 py-4">{item.acuerdo}</td>
                  <td className="px-6 py-4">{item.accion}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

    </motion.div>
  );
};

export default NormasDeConvivencia;
